import { ListMeetingsRequest, ListMeetingsResponse } from '@eigtech/meetings-types'
import {
  QueryClient,
  contextualGet,
  queryOptions,
  useQuery,
  useQueryClient,
} from '@eigtech/ui-shared-api'
import { getAuth0UserNameQueryOptions } from '@eigtech/ui-shared-api-requests'
import { meetingsBasePath, meetingsQueryKeys } from './constants'

async function listMeetings({ entityId }: ListMeetingsRequest) {
  const response = await contextualGet<ListMeetingsResponse>(`${meetingsBasePath}/${entityId}`)
  return response.map((meeting) => {
    const metadata = meeting.metadata ?? {}

    return {
      ...meeting,
      description: meeting.description ?? '',
      metadata: {
        ...metadata,
        label: metadata.label ?? '',
        photo: metadata.photo ?? '',
        description: metadata.description ?? '',
      },
    }
  })
}

export const listMeetingsQueryOptions = (
  { entityId }: ListMeetingsRequest,
  queryClient: QueryClient
) =>
  queryOptions({
    queryKey: meetingsQueryKeys.list({ entityId }),
    queryFn: async () => {
      const meetings = await listMeetings({ entityId })

      return Promise.all(
        meetings.map(async (meeting) => {
          let organizerName = meeting.organizer

          try {
            organizerName = await queryClient.fetchQuery(
              getAuth0UserNameQueryOptions(meeting.organizer)
            )
          } catch {
            //
          }

          return {
            ...meeting,
            organizerName,
          }
        })
      )
    },
  })

export function useListMeetings(request: ListMeetingsRequest) {
  const queryClient = useQueryClient()

  return useQuery(listMeetingsQueryOptions(request, queryClient))
}

export function useInvalidateListMeetings() {
  const queryClient = useQueryClient()

  return function invalidateListMeetings({ entityId }: ListMeetingsRequest) {
    queryClient.invalidateQueries({ queryKey: meetingsQueryKeys.list({ entityId }) })
  }
}
